import { create } from '@theme/create';

export const themed = create(
  new (function () {
    this.wrapper = {
      width: '100%',
    };

    this.heading = {
      variant: 'text.heading',
      fontSize: [6, 7, 8],
      fontWeight: 'bold',
      mb: [4, 5, 6],
    };

    this.comparisonTable = {
      width: '100%',
      maxWidth: '924px',
      mx: 'auto',
      display: 'flex',
      flexDirection: 'column',
      gap: [2, 3],
    };

    this.headerRow = {
      display: 'grid',
      gridTemplateColumns: '2fr 1fr 1fr',
      bg: 'transparent',
      gap: [2, 3],
    };

    this.brandHeader = {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      p: [4, 5],
      bg: 'transparent',
      minHeight: ['120px', '140px'],
    };

    this.brandImage = {
      width: ['60px', '80px'],
      height: ['60px', '80px'],
      objectFit: 'contain',
      mb: 2,
    };

    this.brandName = {
      fontSize: [3, 8],
      fontWeight: '400',
      textAlign: 'center',
    };

    this.comparisonRow = {
      display: 'grid',
      gridTemplateColumns: '2fr 1fr 1fr',
      gap: [2, 3],
    };

    this.featureCell = {
      p: 12,
      bg: '#f5f5f5',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
    };

    this.featureTitle = {
      fontSize: [2, 7],
      fontWeight: '500',
      mb: 3,
      color: 'dark',
    };

    this.featureDescription = {
      fontSize: [1, 6],
      color: 'gray.600',
      lineHeight: 1.4,
    };

    this.statusCell = {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      px: [10, 12],
      py: 12,
      minHeight: ['80px', '90px'],
      bg: 'transparent',
    };

    this.statusIcon = {
      width: ['24px', '32px'],
      height: ['24px', '32px'],
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: ['14px', '18px'],
      fontWeight: 'bold',
    };

    this.checkIcon = {
      ...this.statusIcon,
      bg: '#9ACD32',
      color: 'white',
      border: '2px solid #9ACD32',
    };

    this.crossIcon = {
      ...this.statusIcon,
      bg: 'transparent',
      color: '#666',
      border: '2px solid #666',
    };

    this.partialIcon = {
      ...this.statusIcon,
      bg: 'transparent',
      color: '#999',
      border: '2px solid #999',
    };

    // Mobile responsive adjustments
    this.mobileWrapper = {
      '@media (max-width: 768px)': {
        '.comparison-table': {
          display: 'block',
        },
        '.header-row': {
          display: 'none',
        },
        '.comparison-row': {
          display: 'block',
          mb: 4,
          border: '1px solid',
          borderColor: 'gray.200',
          borderRadius: '8px',
          overflow: 'hidden',
        },
        '.feature-cell': {
          borderBottom: '1px solid',
          borderColor: 'gray.200',
        },
        '.status-row': {
          display: 'grid',
          gridTemplateColumns: '1fr 1fr',
        },
        '.status-cell': {
          flexDirection: 'column',
          gap: 2,
          fontSize: 1,
        },
      },
    };
  })()
);
